module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/gold-collection_5bb5c9.jpg";